import { ScrollContent } from '@components/AppShell'
import { RouteLevelErrorComponent } from '@components/RouteLevelErrorComponent'
import type { RouteObject } from 'react-router'
import { useLocalization } from 'shared-ui/localization'

import { lazy } from './lazy'
import { path } from './paths'

const LogoutMessage = () => {
  const { t } = useLocalization()
  return <div>{t(($) => $.messages.loggedOut)}</div>
}

const errorElement = <RouteLevelErrorComponent />

export const publicRoutes: RouteObject[] = [
  {
    element: <ScrollContent />,
    errorElement,
    children: [
      {
        index: true,
        Component: lazy(() => import('@features/misc/routes/MarketingLanding')),
        errorElement
      },
      {
        path: path.publicEula,
        Component: lazy(() => import('@features/misc/routes/EULA')),
        errorElement
      },
      {
        path: path.refundPolicy,
        Component: lazy(() => import('@features/misc/routes/RefundPolicy')),
        errorElement
      },
      {
        path: path.verifyEmail,
        Component: lazy(() => import('@features/auth/routes/VerifyEmail')),
        errorElement
      },
      {
        path: path.logoutMessage,
        element: <LogoutMessage />,
        errorElement
      },
      {
        path: path.softwareUpdates,
        Component: lazy(() => import('@features/misc/routes/PublicSoftwareRelease')),
        errorElement
      },
      {
        path: path.loginRequired,
        Component: lazy(() => import('@features/auth/routes/LoginRequired')),
        errorElement
      }
    ]
  }
]
